module.exports = __webpack_public_path__ + "images/landing/video-previews/market_listing_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/market_listing_2x.jpg
// module id = j6f8
// module chunks = 1